import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/base/sheet";
import { FeesTab } from "@/presentation/fees/FeesTab";

import { OverlaySection } from "./OverlaySection";
import { StaffTab } from "./StaffTab";

/**
 * The terminal-only surfaces, reached from the Platforms row rather than
 * from tabs of their own.
 *
 * Staff live here rather than in the Profile overlay's People list: a staff
 * member is a terminal operator with permissions and no admin login, so the
 * terminal is where someone goes looking for them.
 */
export function TerminalPlatformSheet({
  open,
  onOpenChange,
  businessId,
  terminalName,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessId: string;
  terminalName: string | null;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full gap-0 p-0 sm:max-w-3xl">
        <SheetHeader className="border-border border-b px-6 py-4">
          <SheetTitle className="text-foreground text-lg font-semibold">
            Terminal
          </SheetTitle>
          {terminalName && (
            <p className="text-muted-foreground font-mono text-xs">
              {terminalName}
            </p>
          )}
        </SheetHeader>

        <div className="overflow-y-auto">
          {open && (
            <>
              <OverlaySection title="Fees">
                <FeesTab businessId={businessId} />
              </OverlaySection>

              <OverlaySection title="Staff">
                <div className="overflow-x-auto">
                  <StaffTab businessId={businessId} />
                </div>
              </OverlaySection>
            </>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
